import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavLink, useMatches } from 'react-router-dom';
import { t } from '@/core/localization';
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';
import { BackLink } from './BackLink';
import { BreadcrumbSeparator } from './BreadcrumbSeparator';
import { BreadcrumbsInnerContainer } from './Breadcrumbs.styled';
const BreadcrumbsBase = ({ backTo, backLinkLabel, lastItem, additionalElement }) => {
    const matches = useMatches();
    // Getting rid of any matches that don't have handle and crumb.
    // Mapping them into an array of elements, passing the loader data along with url parameters to each crumb.
    const crumbs = matches
        .filter((match) => Boolean(match.handle?.crumb))
        .map((match) => match.handle.crumb({ loaderData: match.loaderData, params: matches[0].params }));
    const crumbsWithElement = additionalElement ? crumbs.toSpliced(1, 0, additionalElement) : [...crumbs];
    return (_jsxs(BreadcrumbsInnerContainer, { children: [_jsxs(MuiBreadcrumbs, { separator: _jsx(BreadcrumbSeparator, {}), children: [crumbsWithElement.map((crumb, index) => (_jsx(crumb.type, { ...crumb.props }, index))), lastItem !== undefined && _jsx(NavLink, { to: "#", children: lastItem }), ";"] }), backTo && _jsx(BackLink, { to: backTo, label: backLinkLabel ?? t('back.label') })] }));
};
export { BreadcrumbsBase };
